import { z } from "zod";
import { DateTimeWithOffset } from "@/lib/api/schemas/patterns";

/** Lifecycle status of an invitation. */
export const InvitationStatus = z.enum(["pending", "accepted", "cancelled", "expired"]);
export type InvitationStatus = z.infer<typeof InvitationStatus>;

/** A single invitation row (list item and create response). */
export const InvitationOut = z.object({
  id: z.number(),
  email: z.string(),
  status: InvitationStatus,
  client_id: z.number(),
  client_name: z.string().nullish(),
  invited_by: z.string().nullish(),
  created_at: DateTimeWithOffset,
  expires_at: DateTimeWithOffset,
  accepted_at: DateTimeWithOffset.nullish(),
  account_created: z.boolean().optional(),
  user_id: z.number().nullish(),
  last_login: DateTimeWithOffset.nullish(),
});

/**
 * Body for creating an invitation. `client_id` is required for superusers and
 * ignored for client admins (the backend derives it from their profile).
 */
export const InvitationCreateIn = z.object({
  email: z.string(),
  client_id: z.number().nullish(),
});
